<template>
  <div class="container">
    <div class="top-wrapper">
      <div class="nav-item" id="left-nav-item" @click="goSetting">
        <i class="nav-icon iconfont">&#xe607;</i>
      </div>
      <div class="nav-item" id="right-nav-item" @click="goNews()">
        <i class="nav-icon iconfont">&#xe6ce;</i>
        <span v-if="0"></span>
      </div>
      <div class="top-info-wrapper">
        <div class="avatar-wrapper" @click="goProfileInfo">
          <img
            class="avatar"
            v-bind:src="user.member_avatar+'?'+time"
            v-if="isOnline && user && user.member_avatar"
          />
        </div>
        <label
          class="nickname"
          style="-webkit-box-orient:vertical"
          @click="goProfileInfo"
          >{{ nickname }}</label
        >
      </div>
      <!--<div class="info-wrapper">
        <div class="info-item" @click="goPredeposit">
          预存款{{ getAvailablePredeposit }}
        </div>
        <div class="info-item" @click="goScoreList">{{ getScore }}Points</div>
      </div>-->
      
      <div class="memberlistbox">
	    	<ul>
	    		<li>
	    			<div @click="goCommodity">
	    				<i class="item-icon iconfont">&#xe640;</i><span>Favorite</span>
	    			</div>
	    		</li>
	    		<li @click="goStoreattention">
	    			<div>
	    				<i class="item-icon iconfont icon-mall">&#xe644;</i><span>Follow Stores</span>
	    			</div>
	    		</li>
	    		<li @click="goamaster">
	    			<div>
	    				<i class="item-icon iconfont">&#xe691;</i><span>Video Page</span>
	    			</div>
	    		</li>
	    	</ul>
    </div>
      
    </div>

    
    
    
    <!--<div class="order-header" @click="goOrder">
      <div class="order-header-item" id="order-item-left">
        <label class="item-title order-header-title">My Orders</label>
      </div>
      <div class="order-header-item" id="order-item-right">
        <label class="order-subtitle">All Orders</label>
        <i class="indicator iconfont">&#xe650;</i>
      </div>
    </div>-->
    <!--<div class="order-wrapper">
      <index-order-item
        class="order-item"
        testAttr="MemberOrderList"
        id="state_new"
        iconfont="&#xe664;"
        title="To be paid"
        :orderNumber="user.order_nopay_count"
      >
      </index-order-item>
      <index-order-item
        class="order-item"
        testAttr="MemberOrderList"
        id="state_pay"
        iconfont="&#xe663;"
        title="To be deliveried"
        :orderNumber="user.order_noship_count"
      >
      </index-order-item>
      <index-order-item
        class="order-item"
        testAttr="MemberOrderList"
        id="state_send"
        iconfont="&#xe6a6;"
        title="To be received"
        :orderNumber="user.order_noreceipt_count"
      >
      </index-order-item>
      <index-order-item
        class="order-item"
        testAttr="MemberOrderList"
        id="state_noeval"
        iconfont="&#xe6a7;"
        title="待评价"
        :orderNumber="user.order_noeval_count"
      >
      </index-order-item>
    </div>-->

    <div class="order-header mt-5">
      <div class="order-header-item" id="order-item-left">
        <label class="item-title order-header-title">My Account</label>
      </div>
    </div>
    <div class="manage-wrapper">
      <!--<index-manage-item
        v-on:onclick="goAccount"
        iconfont="&#xe627;"
        color="#990066"
        title="我的钱包"
      >
      </index-manage-item>
      <index-manage-item
        v-on:onclick="goVrOrder"
        iconfont="&#xe6de;"
        color="#003399"
        title="虚拟订单"
      >
      </index-manage-item>
      <index-manage-item
        v-on:onclick="goReturn"
        iconfont="&#xe67a;"
        color="#003399"
        title="退款管理"
      >
      </index-manage-item>-->
      <index-manage-item
        v-on:onclick="goFriendList"
        iconfont="&#xe6f0;"
        color="#CC0033"
        title="Friends"
      >
      </index-manage-item>

      <index-manage-item
        v-if="config && config.instant_message_open == '1' && config.instant_message_gateway_url"
        v-on:onclick="goMemberChatList"
        iconfont="&#xe744;"
        color="#003399"
        title="Messages"
      >
      </index-manage-item>
      <!--<index-manage-item
              v-on:onclick="$router.push({name:'MemberAuth'})"
              iconfont="&#xe69e;"
              color="#F00000"
              title="实名认证"
      >
      </index-manage-item>-->
      <index-manage-item
              v-on:onclick="goFavourite()"
              iconfont="&#xe6c1;"
              color="#9933FF"
              title="Favorites"
      >
      </index-manage-item>
      <index-manage-item
              v-on:onclick="$router.push({ name: 'MemberConsultList' })"
              iconfont="&#xe6cf;"
              color="#33CC33"
              title="Q & A"
      >
      </index-manage-item>
      <index-manage-item
              v-on:onclick="$router.push({ name: 'MemberInformList' })"
              iconfont="&#xe63f;"
              color="#336699"
              title="Reports"
      >
      </index-manage-item>
      <index-manage-item
              v-on:onclick="$router.push({ name: 'MemberComplaintList' })"
              iconfont="&#xe67a;"
              color="#993399"
              title="Complaints"
      >
      </index-manage-item>
      <!--<index-manage-item
              v-on:onclick="goInvoice"
              iconfont="&#xe631;"
              color="#339999"
              title="Invoice"
      >
      </index-manage-item>-->
      <!--<index-manage-item
              v-on:onclick="goAddress"
              iconfont="&#xe6d3;"
              color="#CC3399"
              title="Delivery Address"
      >
      </index-manage-item>-->
      <index-manage-item
              v-on:onclick="goEvaluateList()"
              iconfont="&#xe6a7;"
              color="#CC3333"
              title="My Comments"
      >
      </index-manage-item>

      <index-manage-item
              v-on:onclick="goArrivalnotice()"
              iconfont="&#xe6c4;"
              color="#FF9900"
              title="Arrival Notice"
      >
      </index-manage-item>
      <index-manage-item
              v-on:onclick="goBrowse()"
              iconfont="&#xe691;"
              color="#FF6666"
              title="Browsing History"
      >
      </index-manage-item>
      <index-manage-item
              v-on:onclick="goMemberFeedback()"
              iconfont="&#xe6cd;"
              color="#CC3399"
              title="Feedback"
      >
      </index-manage-item>
    </div>

    <!--<div class="order-header mt-5">
      <div class="order-header-item" id="order-item-left">
        <label class="item-title order-header-title">Promotion Activities</label>
      </div>
    </div>
    <div class="manage-wrapper">
      <index-manage-item
              v-on:onclick="goMarketmanagelog()"
              iconfont="&#xe66e;"
              color="#FF6666"
              title="Activity Records"
      >
      </index-manage-item>
      <index-manage-item
              v-on:onclick="gBargain()"
              iconfont="&#xe670;"
              color="#FF9966"
              title="砍价活动"
      >
      </index-manage-item>
      <index-manage-item
              v-if="config.points_isuse === '1' && config.points_signin_isuse === '1'"
              v-on:onclick="$router.push({name:'MemberPointSignin'})"
              iconfont="&#xe6e6;"
              color="#996600"
              title="我要签到"
      >
      </index-manage-item>
      <index-manage-item
              v-if="config.inviter_open === '1'"
              v-on:onclick="goMemberInviterManage()"
              iconfont="&#xe625;"
              color="#ea51df"
              title="推广管理"
      >
      </index-manage-item>
    </div>-->

		<!-- <div class="order-header mt-5">
      <div class="order-header-item" id="order-item-left">
        <label class="item-title order-header-title">My Video</label>
      </div>
    </div>
    <div class="manage-wrapper">
    	<index-manage-item
              v-on:onclick="addvideo()"
              iconfont="&#xe691;"
              color="#FF9966"
              title="Upload Video"
      >
      </index-manage-item>
    	<index-manage-item
              v-on:onclick="govideoindex()"
              iconfont="&#xe6f0;"
              color="#FF9966"
              title="Information"
      >
      </index-manage-item>
      <index-manage-item
              v-on:onclick="gomyvideo()"
              iconfont="&#xe635;"
              color="#FF6666"
              title="Video List"
      >
      </index-manage-item>
      <index-manage-item
              v-on:onclick="govideotag()"
              iconfont="&#xe628;"
              color="#FF9966"
              title="Video Tag"
      >
      </index-manage-item>
      <index-manage-item
              v-on:onclick="goamaster()"
              iconfont="&#xe6f0;"
              color="#FF9966"
              title="Video Page"
      >
      </index-manage-item>
	</div> -->

    <div class="bottom-wrapper">
      <!-- <index-info-item
        v-if="user.store_id"
        v-on:onclick="goSellerInfo"
        class="mt-5"
        iconfont="&#xe62d;"
        title="Store"
      >
      </index-info-item> -->
      <!--<div v-else>
	  <index-info-item
        v-if="config && config.store_joinin_open!=0"
        v-on:onclick="goSellerJoinin"
		class="mt-5"
        iconfont="&#xe62d;"
        title="商家入驻"
      >
      </index-info-item>
      </div>-->

    </div>
    <!--隐藏猜你喜欢-->
    <!--<guess-like></guess-like>-->
  </div>
</template>

<script>
import IndexInfoItem from './IndexInfoItem'
import IndexOrderItem from './IndexOrderItem'
import IndexManageItem from './IndexManageItem'
import GuessLike from '../../GuessLike'
import { mapState, mapActions } from 'vuex'
import { getMemberIndex } from '../../../api/member'
import { checkInviter } from '../../../api/memberInviter'
import { Toast } from 'mint-ui'
import { getisVideoMan} from '../../../api/video'
export default {
  name: 'MemberIndex',
  data () {
    return {
      user: {},
      time: '',
      orderCount: {},
      isShow: true
    }
  },
  components: {
    IndexOrderItem,
    IndexInfoItem,
    IndexManageItem,
    GuessLike
  },
  created: function () {
    this.time = new Date().getTime()
    this.fetchConfig({}).then(
      response => {
      },
      error => {
        Toast(error.message)
      }
    )
    if (this.isOnline) {
      getMemberIndex().then(
        response => {
          if (response && response.result.member_info) {
            this.user = response.result.member_info
          }
          
          if(response.result.redirecturl){
          	 window.location.href = response.result.redirecturl
          }else{
          	
          }
        },
        error => {}
      )
    }
  },
  computed: {
    ...mapState({
      isOnline: state => state.member.isOnline,
      config: state => state.config.config,
      token: state => state.member.token
    }),

    nickname () {
      let title = 'Login/Register'
      if (this.isOnline) {
        if (
          this.user &&
          typeof this.user !== 'undefined' &&
          JSON.stringify(this.user) !== '{}'
        ) {
          if (this.user.member_truename) {
            title = this.user.member_truename
          } else if (this.user.member_nickname) {
            title = this.user.member_nickname
          }
        }
      }
      return title
    },
    getScore () {
      let score = '0'
      if (this.isOnline && this.user.member_points) {
        score = this.user.member_points
      }
      return score
    },
    // 预存款可用金额 通过store 进行获取
    getAvailablePredeposit () {
      let availablePredeposit = '0.00'
      if (this.isOnline && this.user.available_predeposit) {
        availablePredeposit = this.user.available_predeposit
      }
      return availablePredeposit
    }
  },
  methods: {
    ...mapActions({
      fetchConfig: 'fetchConfig'
    }),
    showLogin () {
      this.$router.push({ name: 'HomeMemberLogin' })
    },
    goScoreList () {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberPointList', query: { index: 0 } })
      } else {
        this.showLogin()
      }
    },
    goOrder () {
      if (this.isOnline) {
        this.$router.push({
          name: 'MemberOrderList'
        })
      } else {
        this.showLogin()
      }
    },
    goProfileInfo () {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberProfileSet' })
      } else {
        this.showLogin()
      }
    },
    goSetting () {
      this.$router.push({ name: 'MemberSetting' })
    },
    // 消息通知
    goNews () {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberNoticeList' })
      } else {
        this.showLogin()
      }
    },
    // 我的关注
    goFavourite () {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberFavorite' })
      } else {
        this.showLogin()
      }
    },
    
    
    // 商品收藏
    goCommodity () {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberFavorite', query: { ids: '2'} })
      } else {
        this.showLogin()
      }
    },
    
    
    // 店铺关注
    goStoreattention () {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberFavorite', query: { ids: '1'} })
        
      } else {
        this.showLogin()
      }
    },
    
    // 我的地址
    goAddress () {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberAddressList' })
      } else {
        this.showLogin()
      }
    },
    // 我的退款
    goReturn () {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberOrderreturn' })
      } else {
        this.showLogin()
      }
    },
    goAccount () {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberAccount' })
      } else {
        this.showLogin()
      }
    },
    goPredeposit () {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberPredepositList' })
      } else {
        this.showLogin()
      }
    },
    // 我的好友列表
    goFriendList () {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberFriendList' })
      } else {
        this.showLogin()
      }
    },
    // 商家入驻
    goSellerJoinin () {
      if (this.isOnline) {
        this.$router.push({ name: 'SellerJoinin1' })
      } else {
        this.showLogin()
      }
    },
    // 聊天列表
    goMemberChatList () {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberChatList' })
      } else {
        this.showLogin()
      }
    },
    // 我的订单评价
    goEvaluateList () {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberEvaluateList' })
      } else {
        this.showLogin()
      }
    },
    // 发票管理
    goInvoice () {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberInvoiceList' })
      } else {
        this.showLogin()
      }
    },
    // 跳转卖家管理中心
    goSellerInfo () {
      if (this.isOnline) {
        this.$router.push({ name: 'SellerIndex' })
      } else {
        this.showLogin()
      }
    },
    // 分销管理中心
    goMemberInviterManage () {
      if (this.isOnline) {
        checkInviter().then(res => {
          this.$router.push({ name: 'MemberInviterManage' })
        }).catch(function (error) {
          Toast(error.message)
        })
      } else {
        this.showLogin()
      }
    },
    // 意见反馈
    goMemberFeedback () {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberFeedback' })
      } else {
        this.showLogin()
      }
    },
    // 虚拟订单
    goVrOrder () {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberVrOrderList' })
      } else {
        this.showLogin()
      }
    },
    // 活动记录
    goMarketmanagelog () {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberMarketmanagelog' })
      } else {
        this.showLogin()
      }
    },
    // 红包领取记录
    goBonusreceive () {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberBonusreceive' })
      } else {
        this.showLogin()
      }
    },
    // 砍价活动
    gBargain () {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberBargainlist' })
      } else {
        this.showLogin()
      }
    },
    // 到货通知
    goArrivalnotice () {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberArrivalnotice' })
      } else {
        this.showLogin()
      }
    },
    // 浏览历史
    goBrowse () {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberBrowseList' })
      } else {
        this.showLogin()
      }
    },
    //前往达人主页
    govideoindex(){
    	if (this.isOnline) {
        this.$router.push({ name: 'MemberVideoIndex' })
      } else {
        this.showLogin()
      }
    },
    //视频标签
    govideotag(){
    	if (this.isOnline) {
        this.$router.push({ name: 'MemberTagList' })
      } else {
        this.showLogin()
      }
    },
    //我的视频
    gomyvideo(){
    	if (this.isOnline) {
        this.$router.push({ name: 'MemberVideoList' })
      } else {
        this.showLogin()
      }
    },
    addvideo:function(){
  		this.$router.push({ name: 'MemberAddVideo'})
  	},
  	//前往达人主页
  	goamaster:function(){
			getisVideoMan(this.user.member_id,this.token).then((res) => {
				if(res.result.isman>0){
					this.$router.push({ name: 'HomeVideoIndex', query: { svideoman_id: res.result.man_info.svideoman_id } })
				}else{
					this.$router.push({ name: 'MemberVideoIndex' })
				}
			})
  	}
  }
}
</script>

<style scoped lang="scss">
.container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  background-color: #f0f2f5;
  .top-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    min-height: 9rem;
    background: linear-gradient(90deg, #e93b3d, #e93b3d);
    .top-info-wrapper {
      flex: 1;
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
    }
  }
  .nav-item {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 0;
    span {
      width: 0.4rem;
      height: 0.4rem;
      background-color: #f0f2f5;
      border-radius: 50%;
      position: absolute;
      top: 0.5rem;
      right: 0.5rem;
    }
  }
  #left-nav-item {
    left: 0;
  }
  #right-nav-item {
    right: 0;
  }
  .nav-icon {
    width: 2rem;
    height: 2rem;
    line-height: 2rem;
    text-align: center;
    font-size: 1.2rem;
    color: #fff;
  }
  .avatar-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 4rem;
    height: 4rem;
    border-radius: 50%;
    background-color: #fff;
    margin-top: 1rem;
    .avatar {
      width: 3.6rem;
      height: 3.6rem;
      border-radius: 50%;
    }
  }
  .nickname {
    width: 100%;
    margin-top: 0.5rem;
    font-size: 0.8rem;
    color: rgba(255, 255, 255, 1);
    text-align: center;
    margin-left: 0;
    margin-right: 0;
  }
  .info-wrapper {
    width: 100%;
    height: 2rem;
    display: inline-flex;
    flex-direction: row;
    justify-content: flex-start;
    align-content: stretch;
    background-color: rgba(0, 0, 0, 0.1);
  }
  .info-item {
    flex: 1;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    color: #fff;
    font-size: 0.7rem;
  }
  .order-header {
    height: 2rem;
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-content: stretch;
    background-color: #fff;
  }
  .order-header-item {
    flex: 1;
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  #order-item-left {
    justify-content: flex-start;
    margin-left: 1rem;
  }
  #order-item-right {
    justify-content: flex-end;
  }
  .item-title {
    font-size: 0.6rem;
    color: #333;
    font-weight:700;
  }
  .order-header-title {
    margin-left: 0.4rem;
  }
  .indicator {
    margin-right: .5rem;
    font-size:0.7rem;
  }
  .order-subtitle {
    font-size: 0.6rem;
    color: #7c7f88;
  }
  .order-wrapper {
    height: 4rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: stretch;
    background-color: #fff;
  }
  .order-item {
    flex: 1;
  }
  .bottom-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    margin-bottom: 1rem;
  }
  .manage-wrapper {
    background: #fff;
  }
}
.memberlistbox{padding:0 0.2rem 0.15rem 0.2rem;background: rgba(0,0,0,0.3);margin-top: 0.6rem;}
.memberlistbox ul{margin: 0;padding: 0;overflow: auto;}
.memberlistbox ul li{width: 33.3%;float: left;box-sizing: border-box;text-align: center;margin: 0;}
.memberlistbox ul li .iconfont{font-size: 0.8rem;display: inline-block;vertical-align: bottom;
color: #fff;display: block;padding-top: 0.2rem;}
.memberlistbox ul li span{font-size: 0.6rem;display: inline-block;color: #fff;}
</style>
